import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

const apiUrl = process.env.REACT_APP_API_URL;

const genderOptions = [
  {
    id: "A",
    value: "66d31c12457c3489795485",
    label: {
      en: "Male",
      Hi: "पुरुष",
      Kn: "ಪುರುಷ",
    },
  },
  {
    id: "B",
    value: "66d31c2486272638130560",
    label: {
      en: "Female",
      Hi: "महिला",
      Kn: "ಮಹಿಳೆ",
    },
  },
  {
    id: "C",
    value: "66d31c42bd15f000864236",
    label: {
      en: "Others",
      Hi: "अन्य",
      Kn: "ಇತರೆ",
    },
  },
];

const translations = {
  en: {
    victimNameLabel: "Name:",
    victimNamePlaceholder: "Type victim name here...",
    victimAgeLabel: "Age:",
    victimAgePlaceholder: "Type victim age here...",
    genderLabel: "Gender:",
    ok: "OK",
    alert: "Please answer the current question before proceeding to the next one.",
    required: "*",
    errorName: "Please enter the victim's name.",
    errorAge: "Please enter the proper age.",
    errorGender: "Please select the victim gender.",
  },
  Hi: {
    victimNameLabel: "नाम:",
    victimNamePlaceholder: "पीड़ित का नाम यहाँ टाइप करें...",
    victimAgeLabel: "आयु:",
    victimAgePlaceholder: "पीड़ित की आयु यहाँ टाइप करें...",
    genderLabel: "लिंग:",
    ok: "ठीक है",
    alert: "कृपया अगला प्रश्न करने से पहले वर्तमान प्रश्न का उत्तर दें।",
    required: "*",
    errorName: "कृपया पीड़ित का नाम दर्ज करें।",
    errorAge: "कृपया सही आयु दर्ज करें।",
    errorGender: "कृपया पीड़ित का लिंग चुनें।",
  },
  Kn: {
    victimNameLabel: "ಹೆಸರು ನಮೂದಿಸಿ:",
    victimNamePlaceholder: "ವಂಚನೆಗೊಳಗಾದ ವ್ಯಕ್ತಿಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ...",
    victimAgeLabel: "ವಯಸ್ಸು:",
    victimAgePlaceholder: "ವಂಚನೆಗೊಳಗಾದ ವ್ಯಕ್ತಿಯ ವಯಸ್ಸು ನಮೂದಿಸಿ...",
    genderLabel: "ಲಿಂಗ:",
    ok: "ಸರಿ",
    alert:
      "ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವುದಕ್ಕೆ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
    required: "*",
    errorName: "ದಯವಿಟ್ಟು ಪೀಡಿತನ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.",
    errorAge: "ದಯವಿಟ್ಟು ಸರಿಯಾದ ವಯಸ್ಸನ್ನು ನಮೂದಿಸಿ.",
    errorGender: "ದಯವಿಟ್ಟು ಪೀಡಿತನ ಲಿಂಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
  },
};

const VictimName = ({
  onNext,
  onVictimNameSelected,
  onVictimAgeSelected,
  onVictimGenderSelected,
  onQuestion,
  answer,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  selectedLang,
}) => {
  const [victimName, setVictimName] = useState("");
  const [victimAge, setVictimAge] = useState("");
  const [gender, setGender] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState({ name: null, age: null, gender: null });

  useEffect(() => {
    const storedName = localStorage.getItem("victimName");
    if (storedName) {
      const parsedName = JSON.parse(storedName);
      setVictimName(parsedName);
      onVictimNameSelected(parsedName);
    }
  }, []);

  useEffect(() => {
    const storedAge = localStorage.getItem("victimAge");
    if (storedAge) {
      const parsedAge = JSON.parse(storedAge);
      setVictimAge(parsedAge);
      onVictimAgeSelected(parsedAge);
    }
  }, []);

  useEffect(() => {
    const storedGender = localStorage.getItem("victimGender");
    if (storedGender) {
      const parsedGender = JSON.parse(storedGender);
      setGender(parsedGender);
      onVictimGenderSelected(parsedGender);
    }
  }, []);

  const handleNameChange = (event) => {
    const inputValue = event.target.value;
    // Allow only alphabets and spaces, with max 100 characters
    if (/^[a-zA-Z\s]*$/.test(inputValue) && inputValue.length <= 100) {
      setVictimName(inputValue);
      onVictimNameSelected(inputValue);
      if (inputValue.length >= 3) {
        setShowOkButton(true);
        setError({ ...error, name: null });
      }
    } else if (!/^[a-zA-Z\s]*$/.test(inputValue)) {
      setError({
        ...error,
        name: 'errorName',
      });
    }
  };

  const handleAgeChange = (event) => {
    const inputValue = event.target.value;
    if (/^\d*$/.test(inputValue)) {
      setVictimAge(inputValue);
      onVictimAgeSelected(inputValue);
      setShowOkButton(true);
      setError({ ...error, age: null });
    }
  };

  const handleOkClick = async (e) => {
    e.preventDefault();

    const age = parseInt(victimAge, 10);
    let valid = true;
    let newError = { name: null, age: null, gender: null };

    if (!victimName) {
      newError.name = 'errorName';
      valid = false;
    }

    if (isNaN(age) || age < 5 || age > 110) {
      newError.age = 'errorAge';
      valid = false;
      setError({ ...error, age:'errorAge' });
    }

    if (!gender) {
      newError.gender = 'errorGender';
      valid = false;
    }

    setError(newError);

    if (valid) {
      localStorage.setItem("victimName", JSON.stringify(victimName));
      localStorage.setItem("victimAge", JSON.stringify(victimAge));
      localStorage.setItem("victimGender", JSON.stringify(gender));
      try {
        const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_victim_data`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f652eaeaef8",
            qtion_num: "6",
            vict_nm: victimName,
            vict_age: victimAge,
            lac_token: botToken,
            app_ver: app_ver,
            gen_id: gender,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        });
        const data = await response.json();
        if (data.resp.error_code === "0") {
          onNext(8);
          onQuestion(9);
          setShowOkButton(true);
          setError({ name: null, age: null, gender: null });
        } else {
          setError({ ...error, name: "Failed to push data to API" });
        }
        if (!response.ok) {
          throw new Error("Failed to push data to API");
        }
      } catch (err) {
        console.error("Error sending data to API:", err);
      }
    } else {
      setShowOkButton(false);
    }
  };

  const handleOptionClick = (option, e) => {
    e.preventDefault();
    setShowOkButton(true);
    setGender(option.value);
    onVictimGenderSelected(option.value);
    setError({ ...error, gender: null });
  };

  return (
    <div className="question" >
      <div className="name-list">
        <h2 htmlFor="victim-name">
          {translations[selectedLang].victimNameLabel}
          <span style={{ color: "red" }}>
            {translations[selectedLang].required}
          </span>
        </h2>
        <input
          type="text"
          className="text-input name"
          value={victimName}
          onChange={handleNameChange}
          placeholder={translations[selectedLang].victimNamePlaceholder}
          id="victim-name"
          autoComplete="off"
        />
        {error.name && <div className="error-message">{translations[selectedLang][error.name]}</div>}
        <div>
          <h2 htmlFor="victim-age">
            {translations[selectedLang].victimAgeLabel}
            <span style={{ color: "red" }}>
              {translations[selectedLang].required}
            </span>
          </h2>
          <div>
            <input
              className="text-input name"
              value={victimAge}
              onChange={handleAgeChange}
              placeholder={translations[selectedLang].victimAgePlaceholder}
              id="victim-age"
              type="text"
              min="5"
              max="110"
              autoComplete="off"
              maxLength="3"
              inputMode="numeric"
            />
            {error.age && <div className="error-message">{translations[selectedLang][error.age]}</div>}
            <div>
              <h2>
                {translations[selectedLang].genderLabel}
                <span style={{ color: "red" }}>
                  {translations[selectedLang].required}
                </span>
              </h2>
              <div style={{ display: "flex", textAlign: "center" }}>
                {genderOptions.map((option) => (
                  <button
                    key={option.id}
                    className={`option-gender-button ${
                      gender === option.value ? "selected" : ""
                    }`}
                    style={{ marginRight: "10px" }}
                    onClick={(e) => handleOptionClick(option, e)}
                  >
                    <div className="answer-container">
                      <div
                        className={`gender-text ${
                          gender === option.value ? "selected" : ""
                        }`}
                        style={{ textAlign: "center" }}
                      >
                        {option.label[selectedLang] || option.label.en}
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
            {error.gender && (
              <div className="error-message">{translations[selectedLang][error.gender]}</div>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            position: "relative",
            zIndex: "9",
          }}
        >
          {showOkButton && (
            <button
              type="button"
              className="ok-btn"
              onClick={handleOkClick}
              style={{ marginTop: "30px" }}
            >
              {translations[selectedLang].ok}
            </button>
          )}
        </div>
        {answer[7] && (
          <p
            className="alert-box"
            style={{ position: "relative", zIndex: "1000" }}
          >
            {translations[selectedLang].alert}
          </p>
        )}
      </div>
    </div>
  );
};

export default VictimName;
